/**
 * Database paths for material mappings collection.
 * 
 * Material mappings define how part description terms resolve to
 * specific inventory materials based on context.
 */

const records = 'material-mappings';

export default {
  records,
};

